import { AdScene } from "../scenes/ad/AdScene";
import { GameScene } from "../scenes/game/GameScene";
import { InfoScene } from "../scenes/info/InfoScene";
import { LoseScene } from "../scenes/lose/LoseScene";
import { RetryScene } from "../scenes/retry/RetryScene";
import { SettingsScene } from "../scenes/settings/SettingsScene";

export enum InjectableFactories {
    GameSceneFactory = "GameSceneFactory",
    InfoSceneFactory = "InfoSceneFactory",
    SettingsSceneFactory = "SettingsSceneFactory",
    LoseSceneFactory = "LoseSceneFactory",
    RetrySceneFactory = "RetrySceneFactory",
    AdSceneFactory = "AdSceneFactory"
}
export type GameSceneFactory = () => Promise<GameScene>;
export type InfoSceneFactory = () => Promise<InfoScene>;
export type SettingsSceneFactory = () => Promise<SettingsScene>;
export type LoseSceneFactory = () => Promise<LoseScene>;
export type RetrySceneFactory = () => Promise<RetryScene>;
export type AdSceneFactory = () => Promise<AdScene>;